import React from "react";

function ChevronDownSvg(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke={props.fill || "#667085"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4.167 7.5L10 13.333 15.833 7.5"
      ></path>
    </svg>
  );
}

export default ChevronDownSvg;
